import api from '../createApi'

export const paymentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPlanDetails:builder.query({
        query: (params) => ({
          url: `plans/getbyproduct`,
          method:'GET',
          params: {...params},
        })
    }),
    getPaymentTypes:builder.query({
      query: () => ({
        url: `paymentmethods/getall`,
        method:'GET'
      })
    }),
    validateCoupon:builder.query({
      query: (params) => ({
        url: `coupon/validatecoupon`,
        method:'GET',
        params: params,
      })
    }),
    chargePayment:builder.mutation({
      query: ({body,params}) =>  ({
        url: `payment/charge`,
        method:'POST',
        body,
        params
      })
    }),
    verifyPayment:builder.query({
      query: ({data}) => ({
        url: `payment/details/${data}`,
        method:'GET',
      })
    }),
    getPurchaseHistory:builder.query({
      query: (params) => ({
        url: `payment/purchasehistory`,
        method:'GET',
        params: params,
      })
    }),
    downloadInvoice:builder.query({
      query: (params) => ({
        url: `payment/invoicedownload`,
        method:'GET',
        params: params,
        responseHandler: async (response) => (await response.blob()),
      })
    }),  
  }),
});

export const {useGetPlanDetailsQuery,useGetPaymentTypesQuery,useLazyValidateCouponQuery,useChargePaymentMutation,useLazyVerifyPaymentQuery,useGetPurchaseHistoryQuery,useLazyDownloadInvoiceQuery} = paymentApi;